<template>
  <div class="container">
    <div class="meet-level trans">
      <meet-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">会议概况</h2>
        <div class="level-item shadow">
          <h2 class="dl-tit">会议详情</h2>
          <div class="group">
            <div>
              <div style="float: left">
                <p class="tips">会议名称:</p>
              </div>
              <div style="float: left">
                <!-- <p class="tips">{{conference.title}}</p> -->
                <!-- <p class="tips">{{conference.title}}</p> -->
                <p v-for="(item, i) in titles" class="tips">{{ item }}</p>
              </div>
            </div>
            <div style="clear: both">
              <p class="tips">会议主题: {{ conference.theme }}</p>
              <p class="tips">
                会议时间: {{ simpleDateFormat(conference.conferencedate) }}
              </p>
              <!-- <p class="tips">会议时间: {{conference.date}}</p> -->
              <p class="tips">会议地点: {{ conference.address }}</p>
            </div>
          </div>
        </div>
        <div class="level-item shadow">
          <h2 class="dl-tit">组织机构</h2>
          <div class="group" style="overflow: auto">
            <div>
              <div style="float: left">
                <p class="tips">主办单位:</p>
              </div>
              <div style="float: left">
                <p v-for="(item, i) in zbcompanys" class="tips">{{ item }}</p>
              </div>
            </div>
            <div style="clear: both"></div>
            <div>
              <div style="float: left">
                <p class="tips">承办单位:</p>
              </div>
              <div style="float: left">
                <!-- <p class="tips">{{conference.title}}</p> -->
                <!-- <p class="tips">{{conference.title}}</p> -->
                <p v-for="(item, i) in cbcompanys" class="tips">{{ item }}</p>
              </div>
            </div>
            <div style="clear: both"></div>
            <div>
              <div style="float: left">
                <p class="tips">协办单位:</p>
              </div>
              <div style="float: left">
                <!-- <p class="tips">{{conference.title}}</p> -->
                <!-- <p class="tips">{{conference.title}}</p> -->
                <p v-for="(item, i) in xbcompanys" class="tips">{{ item }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="level-item shadow">
          <h2 class="dl-tit">嘉宾介绍</h2>
          <div class="group">
            <ul class="list">
              <li class="item" v-for="(item, i) in guests" :key="i">
                <div
                  class="jb-img"
                  @click="handleDetails(item)"
                  v-if="item.image !== null"
                >
                  <img
                    :src="item.image[0].url"
                    alt="嘉宾图片"
                    title="嘉宾图片"
                  />
                </div>
                <div class="jb-info">{{ item.name }}</div>
              </li>
              <!-- <li class="item">
                                <div class="jb-img" ><img src="https://img1.baidu.com/it/u=179390166,3932006802&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=753.jpg" alt="嘉宾图片" title="嘉宾图片"></div>
                                <div class="jb-info">嘉宾介绍信息</div>
                            </li>
                            <li class="item">
                                <div class="jb-img"><img src="https://img1.baidu.com/it/u=179390166,3932006802&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=753.jpg" alt="嘉宾图片" title="嘉宾图片"></div>
                                <div class="jb-info">嘉宾介绍信息</div>
                            </li>
                            <li class="item">
                                <div class="jb-img"><img src="https://img1.baidu.com/it/u=179390166,3932006802&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=753.jpg" alt="嘉宾图片" title="嘉宾图片"></div>
                                <div class="jb-info">嘉宾介绍信息</div>
                            </li>
                            <li class="item">
                                <div class="jb-img"><img src="https://img1.baidu.com/it/u=179390166,3932006802&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=753.jpg" alt="嘉宾图片" title="嘉宾图片"></div>
                                <div class="jb-info">嘉宾介绍信息</div>
                            </li>
                            <li class="item">
                                <div class="jb-img"><img src="https://img1.baidu.com/it/u=179390166,3932006802&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=753.jpg" alt="嘉宾图片" title="嘉宾图片"></div>
                                <div class="jb-info">嘉宾介绍信息</div>
                            </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import meetHeader from "@/components/header"
  import DateMixin from "@/mixin/DateMixin"
  export default {
    name: "meetLevel",
    components: {
      meetHeader,
    },
    mixins: [DateMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "会议概况信息",
        },
        conference: {},
        titles: [], //会议名称分行显示
        zbcompanys: [], //主办单位分行显示
        cbcompanys: [], //承办单位分行显示
        xbcompanys: [], //协办单位分行显示
      }
    },
    async created() {
      if(this.$route.params.conference){
            this.conference = this.$route.params.conference
            this.titles = this.conference.title.split(",")
            this.zbcompanys = this.conference.zbcompany.split(",")
            this.cbcompanys = this.conference.cbcompany.split(",")
            this.xbcompanys = this.conference.xbcompany.split(",")
        }else{
            this.conference  = await this.$store.dispatch("conference/getCurrentConference")
            this.titles = this.conference.title.split(",")
            this.zbcompanys = this.conference.zbcompany.split(",")
            this.cbcompanys = this.conference.cbcompany.split(",")
            this.xbcompanys = this.conference.xbcompany.split(",")
            // this.informList = this.currentConference.informs
        }
      // this.conference = this.$route.params.conference
      // this.titles = this.conference.title.split(",")
      // this.zbcompanys = this.conference.zbcompany.split(",")
      // this.cbcompanys = this.conference.cbcompany.split(",")
      // this.xbcompanys = this.conference.xbcompany.split(",")
    },
    computed:{
      guests(){
        if(this.conference.guests){
          let guests = [...this.conference.guests];
          guests = guests.sort((a,b)=>a.order-b.order)
          return guests
        }
      }
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
      handleDetails(item) {
        this.$router.push({ name: "guestdetail", params: { guest: item }, query: {guest_id: item.id} })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 18px;
      font-weight: bold;
      color: var(--main-color);
    }

    .level-item {
      padding: 15px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 5px;
      margin-top: 25px;

      .dl-tit {
        font-size: 16px;
        color: var(--main-color);
      }

      .group {
        margin-top: 10px;
      }

      .tips {
        font-size: 14px;
        color: #666;
        line-height: 30px;
      }

      .list {
        display: flex;

        flex-wrap: wrap;
        width: 100%;
        margin-top: 30px;
        gap: 15px 15px;

        .item {
          width: 30%;
          text-align: center;

          .jb-img {
            position: relative;
            min-height: 120px;
            max-height: 140px;
            background: #f5f5f5;

            img {
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              width: 100%;
            }
          }

          .jb-info {
            width: 100%;
            line-height: 30px;
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
  }
</style>
